<!-- // download section \\ -->
<section class="download-section edit downloadSecOne"
  [className]="isLoggedin ? 'auth_header download-section edit downloadSecOne' : 'unauth_header download-section edit downloadSecOne'">
  <div class="comman-width">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <h2>{{ secondBrandName }} now available on Apple and Android</h2>

        <span class="rated">Download our FREE top rated app</span>
        <!-- 
        <a href="https://apps.apple.com/us/app/patientrx/id1439777162" target="_blank"><img class="gap" src="assets/images/app-store.png" /></a>
        <a href="https://play.google.com/store/apps/details?id=com.firebase.patientrx" target="_blank"><img src="assets/images/play-store.png" /></a> -->
        <div class="app-link">
          <a href="https://apps.apple.com/us/app/patientrx/id1439777162" target="_blank"><img class="gap"
              src="assets/images/ios.svg" /></a>
          <a href="https://play.google.com/store/apps/details?id=com.firebase.rxhacker&hl=en_IN" target="_blank"><img
              src="assets/images/android.svg" /></a>
        </div>
        <!-- <img class="gap app" src="assets/images/app-store.png" />

        <img class="app" src="assets/images/play-store.png" /> -->

        <span class="get">or get the download link</span>

        <form class="{{ sendmessageClass }}">
          <input type="text" class="form-control" name="mno_p" [(ngModel)]="sendno"
            placeholder="Enter your phone number" (keypress)="removemsgerr($event)" (focus)="removemsgerr($event)"
            autocomplete="off" maxlength="10" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" />
          <button type="submit" class="btn btn-hover-effect" (click)="sendmsg(sendno, '', $event)">
            <div class="insider"></div>
            Get Download Link
          </button>
          <span>{{ sendmessageStatus }}</span>
        </form>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <img src="assets/images/phone.png" class="img-responsive iphone" />
      </div>
    </div>
  </div>
</section>
<!-- \\ download section // -->

<!-- // lowest section \\ -->
<section class="lowest-section edit">
  <div class="comman-width" id="CheckLoginState">
    <app-search></app-search>
  </div>
</section>
<!-- \\ download section // -->

<!-- // discount section \\ -->
<section class="discount-section downloadSecT">
  <div class="comman-width">
    <h2>How {{ secondBrandName }} Works</h2>
    <div class="d-flex">
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 gap">
        <div class="repeat">
          <img src="assets/images/pharmacy-near.png" alt="pharmacy-near" />
          <!-- <span class="line">&nbsp;</span><span class="oval">&nbsp;</span> 10 dec-->
          <h3>Find a Pharmacy Near You</h3>
          <p>
            The NuLifeSpan Rx network spans the entire United States and
            territories. Just enter you zip code and find the pharmacy nearest
            you.
          </p>
        </div>
        <div class="repeat">
          <img src="assets/images/lowest-price.png" alt="pharmacy-near" />
          <h3>Find the Lowest Price</h3>
          <p>
            On behalf of consumers nationwide, NuLifeSpan Rx has negotiated a
            discount rate with a national network of drugstores and retail
            outlets.
          </p>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 m-d-none">
        <img src="assets/images/how-it-works.png" class="img-responsive pharmacy" alt="pharmacy-near" />
      </div>

      <div class="col-lg-4 gap text-right col-md-4 col-sm-4 col-xs-12">
        <div class="repeat">
          <img src="assets/images/discount-card.png" alt="pharmacy-near" />
          <h3>Get Your Discount Card</h3>
          <p>
            Once you have found your medication and the pharmacy nearest you
            generate a discount card that you can print out or send to your
            phone.
          </p>
        </div>
        <div class="repeat">
          <img src="assets/images/search-drug.png" alt="pharmacy-near" />
          <h3>Search for Any Drug</h3>
          <p>
            Search across thousands of medications, dosages, forms and
            quantities to find exactly what you need, when you need it most
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- \\ discount section // -->

<!-- // behalf section \\ -->
<section class="behalf-section downloadSecFour">
  <h2>What will you get</h2>

  <p>
    On behalf of consumers nationwide, {{ brandName }} has negotiated a discount
    rate with a national network of drugstores and retail outlets. More than
    35,000 stores have partnered with {{ brandName }} to offer prescription
    assistance to the uninsured and under-insured.
  </p>

  <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
    <div ngxSlickItem *ngFor="let slide of slides" class="slide">
      <div class="shadow">
        <div class="image">
          <img src="{{ slide.icon }}" />
        </div>
        <span>{{ slide.heading }}</span>
      </div>
    </div>
  </ngx-slick-carousel>
</section>
<!-- \\ behalf section // -->

<!-- // review section \\ -->
<section class="review-section">
  <div class="comman-width">
    <h2><span>App Reviews</span></h2>
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig2">
      <div ngxSlickItem *ngFor="let slide2 of slides2" class="slide">
        <div class="bg">
          <p>{{ slide2.text }}</p>
          <span>{{ slide2.heading }}</span>
          <div class="ratingTag">
            <span>{{ slide2.rating }}</span>
            <ul class="star">
              <li class="enable"></li>
              <li class="enable"></li>
              <li class="enable"></li>
              <li class="enable"></li>
              <li class="enable"></li>
            </ul>
          </div>
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</section>
<!-- \\ review section // -->

<!-- // download section \\ -->
<section class="download-section edit change available">
  <div class="comman-width">
    <div class="row">
      <div class="col-lg-12">
        <h2>{{ secondBrandName }} now available on Apple and Android</h2>

        <span>Download our FREE top rated app</span>

        <!-- <a href="https://apps.apple.com/us/app/patientrx-rx/id1439777162" target="_blank"><img class="gap" src="assets/images/app-store.png" /></a> -->
        <div class="app-link d-app-link">
          <a href="https://apps.apple.com/us/app/patientrx-rx/id1439777162" target="_blank"><img class="gap"
              src="assets/images/ios.svg" /></a>
          <a href="https://play.google.com/store/apps/details?id=com.firebase.rxhacker&hl=en_IN" target="_blank"><img
              src="assets/images/android.svg" /></a>
        </div>
        <!-- <img class="gap" src="assets/images/app-store.png" />

        <img src="assets/images/play-store.png" /> -->

        <span class="get">or get the download link</span>

        <form class="{{ sendmessageClass1 }}">
          <input pattern="[789][0-9]{9}" type="text" class="form-control differ" [(ngModel)]="sendno1" name="mno"
            placeholder="Enter your phone number" (keypress)="removemsgerr($event)" (focus)="removemsgerr($event)"
            maxlength="14" autocomplete="off" />
          <button type="submit" class="btn btn-hover-effect" (click)="sendmsg(sendno1, 'downloadbottom', $event)">
            <div class="insider"></div>
            Get Download Link
          </button>
          <span>{{ sendmessageStatus1 }}</span>
        </form>
      </div>
    </div>
  </div>
</section>
<!-- \\ download section // -->
<!-- <app-getcard></app-getcard> -->